// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3pbyf","overflowing":"ReadFullNote_overflowing__29tec"};